
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1 -1 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 714","d":"M2.4 0C1.087 0 .6.434.6 1.6v6.6a.92.92 0 00.2.612V9.4a.6.6 0 00.6.6h.8a.6.6 0 00.6-.6v-.2h4.4v.2a.6.6 0 00.6.6h.8a.6.6 0 00.6-.6v-.588a.92.92 0 00.2-.612V1.8C9.4.929 9.292 0 8 0zm.6.8h4.2a.2.2 0 01.2.2v.4a.2.2 0 01-.2.2H3a.2.2 0 01-.2-.2V1A.2.2 0 013 .8zm-.8 1.4h5.6a.53.53 0 01.6.6v2.4a.619.619 0 01-.6.587L2.2 5.8a.53.53 0 01-.6-.6V2.8a.53.53 0 01.6-.6zm-1.8.2a.4.4 0 00-.4.4v1.6a.4.4 0 00.4.4zm9.2 0v2.4a.4.4 0 00.4-.4V2.8a.4.4 0 00-.4-.4zM2.3 6.8a.7.7 0 11-.7.7.7.7 0 01.7-.7zm5.4 0a.7.7 0 11-.7.7.7.7 0 01.7-.7zm0 0"}}),_c('path',{attrs:{"data-name":"Rectangle 767","d":"M3.6 0h1v2h-1z"}}),_c('path',{attrs:{"data-name":"Rectangle 768","d":"M5.6 0h1v2h-1z"}})])
          )
        }
      }
    